module.exports = __webpack_public_path__ + "static/media/newsCardOne.4f8ce452.png";